import { AUTO_TEAM_NAME_PREFIX } from './generateAutoTeamName';

/**
 * Checks if a team name is auto-generated (created when excludeTeamName is true).
 * Auto-generated team names use the AUTO_TEAM_NAME_PREFIX ('zqtm_') prefix
 * followed by a timestamp — see generateAutoTeamName.
 *
 * @param {string} teamName - The team name to check
 * @returns {boolean} - True if the team name is auto-generated
 */
export default function isAutoGeneratedTeamName(teamName: string | null | undefined): boolean {
  return !!teamName && teamName.startsWith(AUTO_TEAM_NAME_PREFIX);
}
